import { configureAutoTrack } from '@aws-amplify/analytics';

import { useData } from '@/components';
import { useFeaturedFlag, useSelectedStore } from '@/hooks';

import { AnalyticsRecorder } from './AnalyticsRecorder';

const useAnalytics = () => {
  const { store } = useData();
  const { isSurfsideActive } = useFeaturedFlag();
  const isActive = Boolean(store?.aws_pinpoint_analytics?.active);
  const isGtmActive = true;

  const { store: selectedStore } = useSelectedStore();
  const selectedTreezStoreId = selectedStore?.short_name;

  const { ...analyticsMethods } = new AnalyticsRecorder(
    isActive,
    isSurfsideActive,
    isGtmActive,
    selectedTreezStoreId ?? process.env.NEXT_PUBLIC_TREEZ_DEFAULT_STORE_NAME,
  );

  const initAnalytics = () => {
    if (!isActive) return;

    configureAutoTrack({ type: 'session', enable: true });
    configureAutoTrack({ type: 'pageView', enable: true });
    configureAutoTrack({ type: 'event', enable: true });
  };

  return { ...analyticsMethods, initAnalytics };
};

export { useAnalytics };
